import {
    SmtpCredentialStatus,
    useGetSmtpCredentialForUserQuery,
    useGetUserMailboxesQuery,
    UserMailboxStatus,
} from "generated/graphql";
import { useMemo } from "react";
import { useFeature } from "store/selectors/hooks";
import { getMailboxConnectionState } from "./mailbox-connection-state";

export function useUserMailboxes() {
    const enabled = useFeature("mailboxSync");
    const query = useGetUserMailboxesQuery({}, { enabled });

    const mailboxes = useMemo(() => {
        return query.data?.getUserMailboxes ?? [];
    }, [query.data]);

    const activeMailbox = useMemo(() => {
        return mailboxes.find(m => m.status === UserMailboxStatus.Active);
    }, [mailboxes]);

    const hasActiveMailbox = !!activeMailbox;

    const connectionState = useMemo(
        () => getMailboxConnectionState(mailboxes),
        [mailboxes],
    );

    return {
        mailboxes,
        mailboxesLoaded: query.data !== undefined,
        activeMailbox,
        hasActiveMailbox,
        connectionState,
        refetch: query.refetch,
        enabled,
    };
}

export function useHasActiveSmtpCredential(): boolean {
    const query = useGetSmtpCredentialForUserQuery({});
    return query.data?.getSmtpCredentialForUser?.status === SmtpCredentialStatus.Active;
}
